// src/data/menuData.ts

import { Menu } from "@/types/Menu";
import categories from "@/data/categories";
import services from "@/data/services";

const rentalSubmenu = categories.map((item, index) => ({
  id: index + 1,
  name: item.name,
  title: item.title,
  newTab: item.newTab,
  path: item.url,
}));

const jasaSubmenu = services.map((item, index) => ({
  id: index + 1,
  name: item.name,
  title: item.title,
  newTab: item.newTab,
  path: `/jasa/${item.slug}`,
}));

export const menuData: Menu[] = [
  {
    id: 1,
    name: "RENTAL",
    title: "Produk rental lain untuk disewa",
    newTab: false,
    path: "/rental",
  },
  {
    id: 1,
    name: "JASA",
    title: "Jasa Tenaga IT Profesional",
    newTab: false,
    path: "/jasa",
  },
];

export const mainMenu: Menu[] = [
  {
    id: 1,
    name: "Tentang",
    title: "Tentang Kami",
    newTab: false,
    path: "/tentang-kami",
  },
  {
    id: 2,
    name: "Rental",
    title: "Produk rental lain untuk disewa",
    newTab: false,
    submenu: rentalSubmenu,
  },
  {
    id: 4,
    name: "Jasa",
    title: "Jasa Tenaga IT Profesional",
    newTab: false,
    submenu: jasaSubmenu,
  },
  {
    id: 5,
    name: "Kontak",
    title: "Hubungi Kami",
    newTab: false,
    path: "/kontak",
  },
  {
    id: 6,
    name: "FAQ",
    title: "Pertanyaan yang sering ditanyakan seputar sewa dan jasa",
    newTab: false,
    path: "/faq",
  },
];
